import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormCommission from './Form/FormCommission'

function EditCommission({id , btCancelAction, handleOnSuccess}){
    const [commission, setCommission] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/commission/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            setCommission(response.data.commission)
        })
    }, [token, id])

    async function updateCommission(commission) {
        let msgType = 'success'


        const data = await api.patch(`commission/update/${commission._id}`, commission, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        commission.commission && (
            <FormCommission title="Editar Comissão" handleSubmit={updateCommission} btnText="Salvar" btCancelAction={btCancelAction} commissionData={commission} />
        )
    )
}

export default EditCommission
